import React, { useContext } from 'react';
import defaultStyle from './index.module.scss';
import Modal from '../../atoms/modal';
import SuccessUpload from '../../../assets/succes-upload.svg';
import { perfilSatContext } from '../../../context/perfil.sat.context';

const ModalSuccess: React.FC = () => {
  const {setOpenSuccessModal, successCsdDocuments, successFielDocuments} = useContext(perfilSatContext)

  const getSuccessMessage = () => {
    if (successCsdDocuments && successFielDocuments) {
      return '¡Has actualizado correctamente tus documentos fiscales!';
    }
    if (successCsdDocuments) {
      return 'Ya cargaste tu CSD, recuerda que es necesario que tambien subas tu FIEL en el primer formulario';
    }
    if (successFielDocuments) {
      return 'Ya cargaste tu FIEL, ahora si tienes disponible tu CSD continua con el siguiente formulario';
    }
  }

  return (
    <>
      <Modal isOpen={true} onClose={() => {}}>
        <div className={defaultStyle.container}>
          <img className={defaultStyle.imgPosition} src={SuccessUpload} alt={'SuccessUpload'} />
          <div className={defaultStyle.congrats}>¡Muy bien! 👏🏼 Ya recibimos tus datos</div>
          <div className={defaultStyle.description}>{getSuccessMessage()}</div>
          <button
            className={defaultStyle.button}
            onClick={() => setOpenSuccessModal(false)}
          >
            Volver
          </button>
        </div>
      </Modal>
    </>
  );
}


export default ModalSuccess;